var _g, _g2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIconaPinMappa(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "icona-pin_mappa_progetto",
    "data-name": "icona-pin mappa progetto",
    xmlns: "http://www.w3.org/2000/svg",
    width: 48.509,
    height: 58.537,
    viewBox: "0 0 48.509 58.537",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_306",
    "data-name": "Raggruppa 306"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_254",
    "data-name": "Tracciato 254",
    d: "M506.963,106.691a24.254,24.254,0,1,0-40.668,17.82l-.021.025,16.437,16.437,16.437-16.437-.025-.025A24.156,24.156,0,0,0,506.963,106.691Z",
    transform: "translate(-458.454 -82.435)",
    fill: "#329b5c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_255",
    "data-name": "Tracciato 255",
    d: "M475.806,113.294a13.507,13.507,0,1,1,13.507-13.507A13.5,13.5,0,0,1,475.806,113.294Z",
    transform: "translate(-451.55 -75.531)",
    fill: "#fff"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_257",
    "data-name": "Raggruppa 257",
    transform: "translate(14.684 16.944)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_237",
    "data-name": "Tracciato 237",
    d: "M831.679,580.972h9.743l5,5.082H836.68Z",
    transform: "translate(-827.284 -580.972)",
    fill: "#00853f"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rettangolo_84",
    "data-name": "Rettangolo 84",
    width: 9.173,
    height: 7.27,
    transform: "translate(9.586 6.054)",
    fill: "#00853f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_238",
    "data-name": "Tracciato 238",
    d: "M822.7,584.074l-3.511,3.54h-1.536l4.283-4.318Z",
    transform: "translate(-817.651 -582.568)",
    fill: "#00853f"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconaPinMappa);
export default __webpack_public_path__ + "static/media/icona-pin-mappa.15b9affd9e196211adc2bbf42b78a304.svg";
export { ForwardRef as ReactComponent };